<template>
  <div :class="[$style.box]">
    <div :class="$style.top" :style="{ backgroundImage: `url(${topImg})` }">
      <!-- 返回图标 -->
      <div :class="$style.back" @click="handleBack">
        <img :src="backImg" alt="返回" />
      </div>
      <!-- 搜索栏 -->
      <div :class="$style.search">
        <div :class="$style.searchbar">
          <div :class="$style['searchbar-left']">
            <img :src="searchImg" alt="搜索小图标" />
          </div>
          <div :class="$style['searchbar-content']">
            <input v-model="searchVal" placeholder="王者国度" />
          </div>
          <div :class="$style['searchbar-right']" @click="handleSearch">搜索</div>
        </div>
      </div>
    </div>
    <CircleBaseBox v-if="showSearchGameList" boxTitle="搜索结果">
      <HmGameVertical v-if="hasSearchGameList" :hmGameList="searchGameList" />
      <div v-else :class="$style['no-search']">未搜到任何游戏</div>
    </CircleBaseBox>
    <div v-else>
      <CircleBaseBox boxTitle="热门搜索">
        <HmGameHorizontal :hmGameList="hotGameList" :itemMarginRight="'20px'" />
      </CircleBaseBox>
      <CircleBaseBox boxTitle="历史记录">
        <div :class="$style['history-list']">
          <div v-for="item in searchHistoryList" :key="item.id" :class="$style['history-item']">
            <div :class="$style['history-info']">
              <span>{{ item.content }}</span>
              <img :src="searchClose" @click="delSearchHistoryList(item)" alt />
            </div>
          </div>
        </div>
      </CircleBaseBox>
    </div>
  </div>
</template>

<script>
import NewgameWrapper from '_c/NewgameWrapper';
import CircleBaseBox from '_c/CircleBaseBox';
import HmGameHorizontal from './HmGameHorizontal';
import HmGameVertical from './HmGameVertical';
import { Toast } from "vant";
import { getHmGameList, getSearchHistoryList, delSearchHistoryList, getSearchGameList } from '@/api/gameCenter';
import { mapActions, mapState, mapMutations } from 'vuex';
import { CDN_URL } from "@/config/index.js";
export default {
  components: {
    NewgameWrapper,
    CircleBaseBox,
    HmGameHorizontal,
    HmGameVertical,
    Toast
  },
  data() {
    return {
      hmGamePlates: [],
      topImg: `${CDN_URL}/gameCenter/blank_bg.png`, // 头部背景图
      backImg: `${CDN_URL}/gameCenter/back.png`, // 返回按钮
      catBack: `${CDN_URL}/catBack.png?v=123`,
      searchImg: `${CDN_URL}/gameCenter/search.png`, // 搜索小图标
      searchClose: `${CDN_URL}/close.png`, // 历史搜索关闭按钮
      searchVal: '', // 搜索内容
      hotGameList: [], // 热门搜索游戏列表
      searchHistoryList: [], // 历史记录列表
      searchGameList: [], // 搜索结果
      showSearchGameList: false, // 是否显示搜索结果列表
    }
  },
  computed: {
    ...mapState("account", {
      userInfo: state => state.userInfo // 当前用户信息
    }),
    hasSearchGameList() {
      return this.searchGameList.length ? true : false
    }
  },
  created() {
    this.getHotGameList()
    this.getSearchHistoryList()
  },
  methods: {
    // 获取热门搜索游戏列表
    async getHotGameList() {
      const r = await getHmGameList({ location: 2 });
      // const resList = await getHmGameList({ plate_id: r.result[0].id });
      this.hotGameList = [...r.result]
    },
    // 获取历史记录列表
    async getSearchHistoryList() {
      const r = await getSearchHistoryList();
      this.searchHistoryList = [...r.result];
    },
    // 点击返回
    handleBack() {
      if (this.showSearchGameList) {
        this.showSearchGameList = false
        this.searchVal = ''
        this.getSearchHistoryList()
        return
      }
      this.$emit('hiddenSearch')
    },
    // 点击搜索
    async handleSearch() {
      if (!this.searchVal) {
        this.searchVal = "王者国度";
      }
      const r = await getSearchGameList({ name_like: this.searchVal })
      this.searchGameList = [...r.result]
      this.showSearchGameList = true
    },
    // 删除历史记录列表
    async delSearchHistoryList(item) {
      const r = await delSearchHistoryList({ id: item.id })
      if (r.code === 1) {
        this.getSearchHistoryList()
        Toast("删除成功");
      } else {
        Toast("删除失败");
      }
    }
  },
}
</script>

<style lang="scss" module>
@import '~@/styles/mixins.scss';
@import '~@/styles/animation.scss';
.box {
  width: 100%;
  min-height: 100vh;
  position: relative;
  background-color: #ededed;
}
.top {
  width: 100%;
  min-height: 100px;
  margin-bottom: 8px;
  position: relative;
  background-repeat: no-repeat;
  background-size: 100%;
  .back {
    width: 100%;
    height: 33px;
    > img {
      position: absolute;
      top: 10px;
      left: 10px;
      width: 20px;
      height: 20px;
    }
  }
  // 搜索栏
  .search {
    width: 100%;
    height: 40px;
    .searchbar {
      position: absolute;
      top: 35px;
      left: 50%;
      transform: translateX(-50%);
      width: 253px;
      height: 29px;
      display: flex;
      box-shadow: 0px 3px 6px 0px rgba(60, 10, 10, 0.2);
      border-radius: 14px;
      background-color: #fff;
      .searchbar-left {
        width: 30px;
        height: 100%;
        padding: 5px 0px 0px 10px;
        margin-right: 6px;
        display: flex;
        > img {
          width: 20px;
          height: 20px;
        }
      }
      .searchbar-content {
        width: 180px;
        height: 100%;
        font-size: 12px;
        padding: 2px 0px 2px 0px;
        > input {
          width: 100%;
          height: 25px;
          line-height: 25px;
        }
      }
      .searchbar-right {
        width: 30px;
        line-height: 29px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(159, 159, 159, 1);
        text-align: center;
      }
    }
  }
}
.no-search {
  width: 100%;
  height: 20px;
  text-align: center;
  font-size: 14px;
  color: rgba(159, 159, 159, 1);
  margin-top: 15px;
}
.history-list {
  width: 340px;
  min-height: 438px;
  .history-item {
    width: 100px;
    height: 20px;
    display: inline-block;
    margin-left: 10px;
    margin-top: 20px;
    .history-info {
      display: inline-block;
      min-width: 20px;
      height: 20px;
      line-height: 14px;
      background-color: #f2f2f2;
      border-radius: 10px;
      font-size: 10px;
      padding: 3px 8px;
      > img {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        transform: translate3d(2px, 1px, 0px);
      }
    }
  }
}
</style>
